import { useCallback, useState } from 'react';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { useGoogleLocationApi } from './useGoogleLocationApi';
import { useGeocodeApi } from './useGeocodeApi';
import { useLocation } from './useLocation';

export const useAddressesList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [addresses, setAddresses] = useState([]);

  const { googleMapsSetting, geoCodeSetting, geolocationKey } = useLocation();
  const { googleAutocomplete } = useGoogleLocationApi(googleMapsSetting);
  const { searchAddress: geoCodeSearchAddress } = useGeocodeApi(geoCodeSetting, geolocationKey);

  const resetAddresses = useCallback(() => {
    setIsLoading(false);
    setIsNotFound(false);
    setAddresses([]);
  }, []);

  const fetchAddresses = useCallback(
    debounce(async (searchText: string) => {
      try {
        if (isEmpty(searchText)) {
          resetAddresses();
          return;
        }
        setIsLoading(true);
        const addresses = await (googleMapsSetting.enabled
          ? googleAutocomplete(searchText)
          : geoCodeSearchAddress(searchText));
        setIsNotFound(!addresses.length);
        setAddresses(addresses);
      } finally {
        setIsLoading(false);
      }
    }, 1000),
    [googleMapsSetting]
  );

  return { addresses, fetchAddresses, isNotFound, isLoading, resetAddresses };
};
